import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import classnames from 'classnames';

import combineStyles from '../../utils/combineStyles';
import TypographyStyles from '../../styles/typography';

const styles = theme => ({
  rootBase: {
    backgroundColor: '#F2FAFF',
    border: '1px dashed rgba(12,31,44,0.12)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: 76,
    cursor: 'pointer'
  },
  root: {},
  title: {
    fontWeight: [500, '!important'],
    marginBottom: [theme.spacing.unit * 0.5, '!important']
  },
  message: {
    color: [theme.palette.primary.main, '!important']
  }
});

export const RequiredDocument = ({ t, classes, requiredFile, onClick }) => {
  return (
    <div
      className={classnames(classes.rootBase, classes.root)}
      onClick={() => onClick(requiredFile)}
    >
      <p className={classnames(classes.body2, classes.title)}>
        [{`${t('Insert Required')} ${requiredFile}`}]
      </p>
      <p className={classnames(classes.body2, classes.message)}>
        {t('Click to Add')}
      </p>
    </div>
  );
};

RequiredDocument.propTypes = {
  requiredFile: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

export default withStyles(combineStyles(styles, TypographyStyles))(
  withNamespaces()(RequiredDocument)
);
